/* Sitewide extras: image-copy deterrents, localStorage wishlist (no app — the speed-tax
   doctrine), recently viewed, quick add, cart-drawer upsells via Shopify's native
   recommendations API, gift wrapping and gift note as CART ATTRIBUTES (no phantom product in
   the catalogue), tap-to-copy discount. */
(function () {
  // —— IMAGE-COPY DETERRENTS (sitewide owner — this file loads on every page) ——
  // Blocks the casual grab: right-click → Save image, drag-to-desktop, and the iOS / Android
  // long-press sheet. Paired with the transparent .noget shield in the markup, which is what
  // actually intercepts the long-press.
  //
  // HONEST SCOPE — this is a deterrent, NOT protection. The photos are served from a public
  // CDN, so anyone who opens dev tools, reads the page source, disables JavaScript or simply
  // screenshots still has the file. No website can prevent that. The watermark and copyright
  // are the real defence; this only stops the two-second copy.
  //
  // Scoped to [data-noget] containers on purpose, so right-click keeps working normally on
  // text, links and the rest of the page.
  document.addEventListener('contextmenu', function (ev) {
    if (ev.target.closest('[data-noget]')) ev.preventDefault();
  });
  document.addEventListener('dragstart', function (ev) {
    if (ev.target.closest('[data-noget]')) ev.preventDefault();
  });

  var LS = { wish: 'il:wishlist', recent: 'il:recent' };
  function read(k) { try { return JSON.parse(localStorage.getItem(k)) || []; } catch (e) { return []; } }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  // — wishlist —
  function wl() { return read(LS.wish); }
  function inWl(h) { return wl().some(function (i) { return i.handle === h; }); }
  function wlCount() {
    var n = wl().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n ? '' : 'none';
    });
  }
  function syncButtons() {
    document.querySelectorAll('[data-wish-toggle]').forEach(function (b) {
      var on = inWl(b.getAttribute('data-handle'));
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function renderWl() {
    var box = document.querySelector('[data-wish-items]');
    if (!box) return;
    var list = wl();
    box.innerHTML = list.length ? list.map(function (i) {
      return '<div class="citem"><img src="' + i.img + '" alt="" loading="lazy">' +
        '<div><a class="citem__t" href="/products/' + i.handle + '">' + i.title + '</a>' +
        '<div class="citem__v">' + (i.price || '') + '</div>' +
        '<button data-wish-remove="' + i.handle + '">Remove</button></div><div></div></div>';
    }).join('') : '<p style="padding:24px 0;color:var(--faint)">Nothing saved yet — tap the heart on any rug.</p>';
  }
  function toggleWl(item) {
    var list = wl();
    if (inWl(item.handle)) list = list.filter(function (i) { return i.handle !== item.handle; });
    else list.unshift(item);
    write(LS.wish, list.slice(0, 50));
    wlCount(); syncButtons(); renderWl();
  }
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-wish-toggle]');
    if (t) {
      ev.preventDefault();
      toggleWl({ handle: t.getAttribute('data-handle'), title: t.getAttribute('data-title'), img: t.getAttribute('data-img'), price: t.getAttribute('data-price') });
      return;
    }
    if (ev.target.closest('[data-open-wish]')) { ev.preventDefault(); renderWl(); document.body.classList.add('wish-open'); return; }
    if (ev.target.closest('[data-close-wish]') || (ev.target.classList && ev.target.classList.contains('scrim'))) document.body.classList.remove('wish-open');
    var rm = ev.target.closest('[data-wish-remove]');
    if (rm) toggleWl({ handle: rm.getAttribute('data-wish-remove') });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.body.classList.remove('wish-open'); });
  wlCount(); syncButtons();

  // — tap-to-copy discount code in the announcement bar —
  // Two paths on purpose: the async Clipboard API is blocked in some in-app browsers and
  // embedded webviews, so a hidden-textarea execCommand copy backs it up. The shopper is
  // told what happened either way — a silent no-op reads as a broken button.
  function legacyCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:absolute;left:-9999px;top:0';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) { return false; }
  }
  document.addEventListener('click', function (ev) {
    var tap = ev.target.closest('[data-copy-code]');
    if (!tap) return;
    var code = tap.getAttribute('data-copy-code');
    var hint = tap.querySelector('[data-copy-hint]');
    var say = function (msg) {
      if (!hint) return;
      hint.textContent = msg;
      setTimeout(function () { hint.textContent = 'tap to copy'; }, 2400);
    };
    var fallback = function () { say(legacyCopy(code) ? 'copied ✓' : 'code: ' + code); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { say('copied ✓'); }).catch(fallback);
    } else fallback();
  });

  // — recently viewed: capture on PDP, render wherever [data-recent] exists —
  var pd = document.querySelector('[data-product-json]');
  var cur = null;
  if (pd) {
    try {
      var p = JSON.parse(pd.textContent);
      cur = p.handle;
      var list = read(LS.recent).filter(function (i) { return i.handle !== p.handle; });
      list.unshift(p);
      write(LS.recent, list.slice(0, 12));
    } catch (e) {}
  }
  var rec = document.querySelector('[data-recent]');
  if (rec) {
    var items = read(LS.recent).filter(function (i) { return i.handle !== cur; }).slice(0, 8);
    if (items.length) {
      rec.hidden = false;
      rec.querySelector('[data-recent-row]').innerHTML = items.map(function (i) {
        return '<div><a class="pcard" href="/products/' + i.handle + '"><div class="pcard__media" data-noget><img src="' + i.img + '" alt="" loading="lazy" draggable="false"><span class="noget"></span></div>' +
          '<div class="pcard__body"><div class="pcard__title">' + i.title + '</div><div class="pcard__price">' + (i.price || '') + '</div></div></a></div>';
      }).join('');
    }
  }

  // — quick add (cards, upsells): add one variant, then open the cart drawer —
  function addVariant(id, btn) {
    if (btn) { btn.setAttribute('data-busy', '1'); btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () { var oc = document.querySelector('[data-open-cart]'); if (oc) oc.click(); })
      .catch(function () { if (btn) btn.textContent = 'Unavailable'; })
      .finally(function () {
        if (btn && btn.textContent === 'Adding…') btn.textContent = btn.getAttribute('data-label') || 'Quick add';
        if (btn) btn.removeAttribute('data-busy');
      });
  }
  document.addEventListener('click', function (ev) {
    var q = ev.target.closest('[data-quick-add]');
    if (q && !q.getAttribute('data-busy')) { ev.preventDefault(); ev.stopPropagation(); addVariant(q.getAttribute('data-quick-add'), q); }
  });

  // — gift wrapping + gift note: cart ATTRIBUTES, not a phantom ₹0 product in the catalogue
  //   (a gift-wrap product would land in the price-rule collections and the Shopping feed) —
  var wrapBox = document.querySelector('[data-giftwrap]');
  if (wrapBox) {
    var chk = wrapBox.querySelector('input[type=checkbox]');
    var note = wrapBox.querySelector('textarea');
    var save = function () {
      var attrs = { 'Gift wrapping': chk.checked ? 'Yes — complimentary' : '', 'Gift note': chk.checked ? (note.value || '') : '' };
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
      note.hidden = !chk.checked;
    };
    chk.addEventListener('change', save);
    var t = null;
    note.addEventListener('input', function () { clearTimeout(t); t = setTimeout(save, 600); });
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var a = c.attributes || {};
      chk.checked = !!a['Gift wrapping'];
      note.value = a['Gift note'] || '';
      note.hidden = !chk.checked;
    });
  }

  // — cart drawer upsells: recommendations off the first cart line, skip what's in the cart —
  var upsell = document.querySelector('[data-upsell]');
  if (upsell) {
    document.addEventListener('click', function (ev) {
      if (!ev.target.closest('[data-open-cart]')) return;
      setTimeout(function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          if (!cart.items.length) { upsell.hidden = true; return; }
          return fetch('/recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=4&intent=related')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var ids = cart.items.map(function (i) { return i.product_id; });
              var prods = (d.products || []).filter(function (p) { return ids.indexOf(p.id) < 0 && p.available; }).slice(0, 3);
              if (!prods.length) { upsell.hidden = true; return; }
              upsell.hidden = false;
              upsell.querySelector('[data-upsell-row]').innerHTML = prods.map(function (p) {
                var v = p.variants && p.variants[0];
                var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') >= 0 ? '&' : '?') + 'width=96' : '';
                return '<div class="upsell__item" data-noget><img src="' + img + '" alt="" loading="lazy" draggable="false">' +
                  '<div><a href="' + p.url + '">' + p.title + '</a><small>$' + (p.price / 100).toFixed(2) + '</small></div>' +
                  (v ? '<button class="upsell__add" data-quick-add="' + v.id + '" data-label="Add">Add</button>' : '') + '</div>';
              }).join('');
            });
        });
      }, 350);
    });
  }
})();
